<template>
    <!-- Title on the left, previous/next arrows on the right. -->
    <div    class="flex w-full items-center justify-between">
        <span   class="font-semibold text-gray-900">{{ title }}</span>
        <div    class="flex gap-1">
            <button type="button"
                    class="drp-nav"
                    :aria-label="'Previous ' + unit"
                    :disabled="prevDisabled"
                    @click="$emit('prev')"
            ><tabler-icon name="arrowLeft" size-class="h-4 w-4"></tabler-icon></button>
            <button type="button"
                    class="drp-nav"
                    :aria-label="'Next ' + unit"
                    :disabled="nextDisabled"
                    @click="$emit('next')"
            ><tabler-icon name="arrowRight" size-class="h-4 w-4"></tabler-icon></button>
        </div>
    </div>
</template>

<script>
import TablerIcon from "@/components/elements/TablerIcon.vue"
export default {
    name: 'DateRangeNav',
    components: {TablerIcon},
    emits: ['prev', 'next'],
    props: {
        title: {
            type: String,
            required: true,
        },
        // Used in the arrows' aria-labels ("Previous month").
        unit: {
            type: String,
            default: 'month',
        },
        prevDisabled: {
            type: Boolean,
            default: false,
        },
        nextDisabled: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped>
.drp-nav {
    display: flex;
    height: 2.4rem;
    width: 2.4rem;
    align-items: center;
    justify-content: center;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    background: #fff;
    color: #111827;
}

.drp-nav:disabled {
    cursor: not-allowed;
    opacity: 0.4;
}
</style>
